import { styled } from '@mui/material';

export const OverlayStatsContainer = styled('div')`
  > div {
    left: auto !important;
    right: 33% !important;
  }
`;
